import Store, { TestStore } from "../../../shared/functions/store";
import { loadWebtexte, callService } from "@phoenixreisen/gateway";
import { getBookingName } from "../../../shared/functions/booking";
import { jwtDecode } from "jwt-decode";
import User from "@phoenixreisen/user";
import Config from "../../../config";
import Bowser from "bowser";
export async function getWebtexte() {
    const categories = [
        "login__ueberschrift",
        "login__infosatz",
        "login__pw__hint",
        "login__pw__text",
        "login__buchung_nicht_gefunden",
        "login__mp__kennenlernen__text",
        "login__mp__kennenlernen__info",
        "login__mp__kennenlernen__headline",
        "login__text_reise_abgesagt__flug",
        "login__text_reise_abgesagt__schiff",
        "agenturlogin__buchung_nicht_gefunden",
        "agenturlogin__mandat_entzogen",
        "agenturlogin__infosatz",
    ];
    return loadWebtexte(categories, "webtexte.login");
}
export async function saveContactWays(jwt, username, email, phone = null) {
    return callService("phxauth.mitarbeiter", {
        type: "mitarbeiter-daten-aendern",
        "benutzer-kennung": username,
        "mitarbeiter-daten": {
            mobilnummer: phone || undefined,
            email: email,
        },
        jwt: jwt,
    });
}
export async function getSampleBooking() {
    return callService("rpc.meinphoenixservices.musterbuchung", {
        type: "erstelle-musterbuchung",
    });
}
export function isLoggedIn(agencynr, jwt) {
    const { storageKeyAgencyNr, storageKeyJWT } = Config;
    if (!jwt || !jwt.length || !agencynr) {
        return false;
    }
    try {
        const props = jwtDecode(jwt);
        const exp = new Date(props.exp);
        const now = new Date();
        if (props.kind !== "Agentur") {
            return false;
        }
        else if (agencynr !== props.sub) {
            return false;
        }
        else if (exp <= now) {
            return false;
        }
        Store.set(storageKeyJWT, jwt);
        Store.set(storageKeyAgencyNr, agencynr);
        User.jwt = jwt;
        User.persist();
        return true;
    }
    catch {
        return false;
    }
}
export function isLocalStorageDisabled() {
    try {
        TestStore.set("test", "passed");
        TestStore.get("test");
        TestStore.remove("test");
        return false;
    }
    catch {
        return true;
    }
}
export function isDinosaurBrowser() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.satisfies({
        windows: {
            "internet explorer": "<11",
        },
        safari: "<8",
        chrome: "<67",
        firefox: "<58",
    });
}
export function getLogins() {
    try {
        const key = Config.storageKeyLastLogins;
        return (Store.get(key) || []);
    }
    catch {
        return [];
    }
}
export function saveLastLogins(list) {
    try {
        Store.set(Config.storageKeyLastLogins, list);
    }
    catch {
    }
}
export function saveLoginToLastLogins(booking, maxEntries = 10) {
    const lastname = getBookingName(booking);
    const rechnr = booking["buchung/rech-nr"];
    const start = booking["buchung/reisezeitraum"]?.[0] ?? null;
    const title = booking["buchung/routen"]?.[0]?.["route/reise-titel"] ?? null;
    const route = booking["buchung/routen"]?.[0]?.["route/link-routenkarte"] ?? null;
    const stored = (Store.get(Config.storageKeyLastLogins) || []);
    const entry = stored.find((e) => e.rechnr === rechnr && e.lastname === lastname);
    try {
        if (!entry) {
            const list = [{ rechnr, lastname, start, title, route }, ...stored].slice(0, maxEntries);
            Store.set(Config.storageKeyLastLogins, list);
        }
        else {
            entry.start = start;
            entry.title = title;
            entry.route = route;
            Store.set(Config.storageKeyLastLogins, stored);
        }
    }
    catch {
    }
}
